// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Link from "@material-ui/icons/Link";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import React from "react";
import Select from "react-select";
import "react-table/react-table.css";

import { api_url, app_url } from 'redux/config.js';
import { connect } from 'react-redux';
import Toast from 'views/Toast/Toast';
import axios from 'axios';
import QRCode from "qrcode.react"
import jsPDF from "jspdf"
import moment from "moment"
import commonStyle from "assets/jss/common/common"
import CustomSelect from "components/CustomSelect/CustomSelect"
import { withTranslation } from "react-i18next";

// Embed a Unicode font so the PDF header renders Greek/other non-Latin text correctly
// (the default jsPDF Helvetica is Latin-1 only and produces mojibake). Kept after all imports
// to satisfy the import/first lint rule (matches TextReports.jsx).
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-normal.js')
require('assets/fonts/dejavu-sans-ttf-2.34/DejaVuSans-bold.js')
const styles = {
  ...regularFormsStyle,
  ...notificationsStyle,
  descriptionTextArea: {
    width: "100%",
    height: 150
  },
  flexBaseLine: {
    display: 'flex;',
    alignItems: 'baseline;'
  }
};
class CreateSurveyLinkPage extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props
    this.state = {
      selected_survey: null,
      selectedType: { label: t("Answer By Adding Email"), value: 'email' },
      survey_full: [],
      surveys: [],
      survey_url: '',
      types: [
        { label: t("Answer By Adding Email"), value: 'email' },
        { label: t("Free to Answer"), value: 'nocondition' },
        { label: t("Protection With ID Password"), value: 'password' },
        { label: "Room number | Αριθμός δωματίου | Zimmernummer", value: 'freeid' },
        { label: t("Emojies + Flags at the Beginning"), value: 'emoji_flag_start' },],
      eccs: [
        {
          label: "L-smallest",
          value: "L"
        },
        {
          label: "M",
          value: "M"
        },
        {
          label: "Q",
          value: "Q"
        },
        {
          label: "H-best",
          value: "H"
        }
      ],
      sizes: [],
      selected_size: {
        label: 'Size',
        value: 50
      },
      selected_level: {
        label: "M",
        value: "M"
      },
      // --- Per-location QR (rooms / tables / Σημεία) ---
      rangeFrom: '',
      rangeTo: '',
      ranges: [],           // [{ from, to }]
      extraList: '',        // comma-separated irregular locations (e.g. T1,VIP)
      perPage: { label: '6 / page', value: 6 },
      perPageOptions: [
        { label: '1 / page', value: 1 },
        { label: '2 / page', value: 2 },
        { label: '4 / page', value: 4 },
        { label: '6 / page', value: 6 },
      ],
      caption: 'SCAN TO ANSWER',
      labelPrefix: 'Room',
      headerTitle: '',
      pdfLocations: [],     // locations rendered as hidden QR canvases before export
    };
    this.locationWrapRef = React.createRef();
  }
  normalize = (response) => {
    const survey_full = response.data.data;
    const surveys = response.data.data.map((item) => ({
      label: item.main[0].title,
      value: item.id
    }))

    this.setState({
      surveys, survey_full
    })
  }
  onLoad = () => {
    let self = this;
    const url = api_url + `getall`;
    const header = 'Bearer '.concat(this.props.user.token);
    let headers = null;
    if (this.props.user.token) {
      headers = {
        Authorization: header
      };
    }
    this.props.dispatch({ type: 'LOAD_START' });
    axios({ url: api_url + 'survey/all_active', method: 'get', headers })
      .then(function (response) {
        self.normalize(response)
        self.props.dispatch({ type: 'LOAD_END' });
      })
      .catch(function (errors) {
        console.info(errors);
        self.props.dispatch({ type: 'LOAD_END' });
        if (!errors.response) {
          Toast(500);
          return;
        }
        Toast(errors.response.status);
      });
  };
  componentDidMount() {
    this.onLoad()
    let sizes = [];
    for (let i = 50; i <= 500; i += 50) {
      sizes.push({
        label: `${i}*${i}`,
        value: i
      });
    }
    this.setState({ sizes, selected_size: sizes[0] });
  }
  generateSurveyLink = () => {
    const selected_survey = this.state.selected_survey
    const selectedType = this.state.selectedType
    let url = `${app_url}/public/single_survey/${selected_survey.value}/${selectedType.value}`
    if (selectedType.value === 'emoji_flag_start' || selectedType.value === 'emoji_flag_top') {
      url = `${app_url}/public/single_survey_emoji/${selected_survey.value}/${selectedType.value}`
    }
    this.setState({
      survey_url: url
    })
  }
  copyLink = () => {
    const { t } = this.props
    this.copyToClipboard(this.state.survey_url)
    Toast(200, t('Copied to clipboard'));
  }
  copyToClipboard = str => {
    const el = document.createElement('textarea');  // Create a <textarea> element
    el.value = str;                                 // Set its value to the string that you want copied
    el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px';                      // Move outside the screen to make it invisible
    document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection().rangeCount > 0        // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0)     // Store selection if found
        : false;                                    // Mark as false to know no selection existed before
    el.select();                                    // Select the <textarea> content
    document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el);                  // Remove the <textarea> element
    if (selected) {                                 // If a selection existed before copying
      document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
      document.getSelection().addRange(selected);   // Restore the original selection
    }
  };

  // --- Per-location QR helpers -------------------------------------------------
  // Build the public survey URL for one location, carrying the current answer type
  // and the location as ?location=. Orthogonal to the type: a location QR can still
  // ask for email/password if that type is selected.
  locationQrUrl = (loc) => {
    const { selected_survey, selectedType } = this.state
    let base = `${app_url}/public/single_survey/${selected_survey.value}/${selectedType.value}`
    if (selectedType.value === 'emoji_flag_start' || selectedType.value === 'emoji_flag_top') {
      base = `${app_url}/public/single_survey_emoji/${selected_survey.value}/${selectedType.value}`
    }
    return `${base}?location=${encodeURIComponent(loc)}`
  }

  addRange = () => {
    const { t } = this.props
    const from = parseInt(this.state.rangeFrom, 10)
    const to = parseInt(this.state.rangeTo, 10)
    if (isNaN(from) || isNaN(to) || from > to) {
      Toast(400, t('Invalid range (from must be <= to)'))
      return
    }
    this.setState({ ranges: [...this.state.ranges, { from, to }], rangeFrom: '', rangeTo: '' })
  }

  removeRange = (idx) => {
    this.setState({ ranges: this.state.ranges.filter((_, i) => i !== idx) })
  }

  // Expand ranges + free-text list into an ordered, de-duplicated list of locations.
  computeLocations = () => {
    const out = []
    const seen = {}
    const push = (v) => {
      const s = ('' + v).trim()
      if (s && !seen[s]) { seen[s] = true; out.push(s) }
    }
    this.state.ranges.forEach(({ from, to }) => { for (let i = from; i <= to; i++) push(i) })
    this.state.extraList.split(',').forEach(push)
    return out
  }

  generateLocationPdf = () => {
    const { t } = this.props
    if (!this.state.selected_survey) { Toast(400, t('Please choose a survey')); return }
    const locations = this.computeLocations()
    if (locations.length === 0) { Toast(400, t('No locations defined')); return }
    if (locations.length > 1000) { Toast(400, t('Too many locations (max 1000)')); return }
    // Render the hidden QR canvases first, then build the PDF once they are painted.
    this.setState({ pdfLocations: locations }, () => {
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(() => this.buildPdf(locations)))
    })
  }

  buildPdf = (locations) => {
    const { t } = this.props
    const perPage = this.state.perPage.value
    const layout = { 1: { cols: 1, rows: 1 }, 2: { cols: 1, rows: 2 }, 4: { cols: 2, rows: 2 }, 6: { cols: 2, rows: 3 } }[perPage]
    const doc = new jsPDF('p', 'mm', 'a4')
    doc.setFont('DejaVuSans')
    const pageW = doc.internal.pageSize.getWidth ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width
    const pageH = doc.internal.pageSize.getHeight ? doc.internal.pageSize.getHeight() : doc.internal.pageSize.height
    const margin = 12
    const headerH = 16
    const title = this.state.headerTitle || (this.state.selected_survey && this.state.selected_survey.label) || 'QR Codes'
    const prefix = (this.state.labelPrefix || '').trim()
    const caption = (this.state.caption || '').trim()
    const generated = moment().format('YYYY-MM-DD HH:mm')
    const totalPages = Math.ceil(locations.length / perPage)
    const gridTop = margin + headerH
    const cellW = (pageW - margin * 2) / layout.cols
    const cellH = (pageH - gridTop - margin) / layout.rows
    const wrap = this.locationWrapRef.current

    locations.forEach((loc, i) => {
      const posOnPage = i % perPage
      if (i > 0 && posOnPage === 0) doc.addPage()
      if (posOnPage === 0) {
        const pageNo = Math.floor(i / perPage) + 1
        doc.setFont('DejaVuSans', 'bold'); doc.setFontSize(12); doc.setTextColor(0)
        doc.text(title, margin, margin + 4)
        doc.setFont('DejaVuSans', 'normal'); doc.setFontSize(9); doc.setTextColor(120)
        doc.text(`${t('QR Code Sheet')}${prefix ? ' · ' + prefix : ''}`, margin, margin + 10)
        doc.text(`${t('Page')} ${pageNo} ${t('of')} ${totalPages}`, pageW - margin, margin + 4, { align: 'right' })
        doc.text(`${t('Generated')} ${generated}`, pageW - margin, margin + 10, { align: 'right' })
      }
      const col = posOnPage % layout.cols
      const row = Math.floor(posOnPage / layout.cols)
      const cx = margin + col * cellW
      const cy = gridTop + row * cellH
      doc.setFont('DejaVuSans', 'bold'); doc.setTextColor(0); doc.setFontSize(perPage <= 2 ? 16 : 12)
      if (caption) doc.text(caption, cx + cellW / 2, cy + 8, { align: 'center' })
      const qrSize = Math.max(20, Math.min(cellW, cellH) - 26)
      const canvas = wrap ? wrap.querySelector(`#loc-qr-${i} canvas`) : null
      if (canvas) {
        doc.addImage(canvas.toDataURL('image/png'), 'PNG', cx + (cellW - qrSize) / 2, cy + 12, qrSize, qrSize)
      }
      doc.setFont('DejaVuSans', 'bold'); doc.setTextColor(20, 60, 120); doc.setFontSize(perPage <= 2 ? 18 : 13)
      doc.text(`${prefix ? prefix + ' ' : ''}${loc}`, cx + cellW / 2, cy + 12 + qrSize + 8, { align: 'center' })
    })
    doc.save(`${(title || 'qr').replace(/[^\w\-]+/g, '_')}_locations.pdf`)
    this.setState({ pdfLocations: [] })
    Toast(200, t('PDF generated'))
  }

  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="success" icon>
                <CardIcon color="success">
                  <Link />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{t('Create survey link')}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} md={12}>
                    <SnackbarContent
                      fullWidth
                      message={
                        t('Answer Type Choose, one of the options bellow how you need to protect you Survey.')
                      }
                      color="info"
                    />
                  </GridItem>

                  <GridItem xs={12}>
                    {this.state.types.map((item, key) => {
                      return (
                        <Button
                          key={key}
                          size="sm"
                          onClick={() => {
                            this.setState({
                              selectedType: item
                            });
                          }}
                          color={
                            item.value === this.state.selectedType.value ? "info" : null
                          }
                        >
                          {item.label}
                        </Button>
                      );
                    })}
                  </GridItem>
                  <GridItem xs={12}>
                    <CustomSelect
                      onChange={selvalue => {
                        this.setState({
                          selected_survey: selvalue
                        })
                      }}
                      placeholder={t('Survey')}
                      options={this.state.surveys}
                    />
                  </GridItem>
                  <GridItem xs={12}>

                    <div className={classes.flexBaseLine}>
                      <CustomInput
                        labelText={t('SURVEY LINK')}
                        id="SURVEYLINK"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          type: "text",

                          value: this.state.survey_url,
                          disabled: true
                        }}
                      />
                      <Button size="sm" color="info" onClick={this.copyLink}>{t('Copy')}</Button>
                    </div>
                    <div>
                      <Button color="success" disabled={!this.state.selected_survey} onClick={this.generateSurveyLink}>
                        {t('Create Survey Link, QR code')}
                      </Button>
                    </div>
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <p>{t('ECC')}</p>
                    <CustomSelect
                      onChange={level => { this.setState({ selected_level: level }) }}
                      placeholder="ECC"
                      value={this.state.selected_level}
                      options={this.state.eccs}
                    />
                    <br />
                    <p>{t('Size')}</p>
                    <CustomSelect
                      onChange={size => { this.setState({ selected_size: size }) }}
                      placeholder="Size"
                      value={this.state.selected_size}
                      options={this.state.sizes}
                    />
                  </GridItem>
                  <GridItem xs={12} md={6}>
                    <p>{t('QR image')}</p>
                    {
                      this.state.survey_url && <QRCode value={this.state.survey_url} level={this.state.selected_level.value} size={this.state.selected_size.value} />
                    }

                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>

          {/* ---- Per-location QR codes (rooms / tables / Σημεία) ---- */}
          <GridItem xs={12} sm={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <Link />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {t('Per-location QR codes')} — {t('Rooms / Tables / Locations')}
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12}>
                    <SnackbarContent
                      fullWidth
                      message={t('Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.')}
                      color="info"
                    />
                  </GridItem>

                  {/* Ranges */}
                  <GridItem xs={12} sm={4}>
                    <CustomInput
                      labelText={t('From')}
                      id="rangeFrom"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'number', value: this.state.rangeFrom, onChange: (e) => this.setState({ rangeFrom: e.target.value }) }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4}>
                    <CustomInput
                      labelText={t('To')}
                      id="rangeTo"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'number', value: this.state.rangeTo, onChange: (e) => this.setState({ rangeTo: e.target.value }) }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={4} style={{ alignSelf: 'center' }}>
                    <Button size="sm" color="info" onClick={this.addRange}>{t('Add range')}</Button>
                  </GridItem>

                  {this.state.ranges.length > 0 &&
                    <GridItem xs={12}>
                      {this.state.ranges.map((r, idx) => (
                        <Button key={idx} size="sm" color="rose" onClick={() => this.removeRange(idx)}>
                          {r.from}–{r.to} ✕
                        </Button>
                      ))}
                    </GridItem>
                  }

                  <GridItem xs={12}>
                    <CustomInput
                      labelText={t('Extra locations (comma-separated, e.g. T1, T2, VIP)')}
                      id="extraList"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'text', value: this.state.extraList, onChange: (e) => this.setState({ extraList: e.target.value }) }}
                    />
                  </GridItem>

                  {/* Sheet options */}
                  <GridItem xs={12} sm={6} md={3}>
                    <p>{t('QR per page')}</p>
                    <CustomSelect
                      onChange={(v) => this.setState({ perPage: v })}
                      placeholder={t('QR per page')}
                      value={this.state.perPage}
                      options={this.state.perPageOptions}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={3}>
                    <CustomInput
                      labelText={t('Label prefix (Room / Table / Σημείο)')}
                      id="labelPrefix"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'text', value: this.state.labelPrefix, onChange: (e) => this.setState({ labelPrefix: e.target.value }) }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={3}>
                    <CustomInput
                      labelText={t('Caption (e.g. SCAN TO ANSWER)')}
                      id="caption"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'text', value: this.state.caption, onChange: (e) => this.setState({ caption: e.target.value }) }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6} md={3}>
                    <CustomInput
                      labelText={t('Sheet title (defaults to survey name)')}
                      id="headerTitle"
                      formControlProps={{ fullWidth: true }}
                      inputProps={{ type: 'text', value: this.state.headerTitle, onChange: (e) => this.setState({ headerTitle: e.target.value }) }}
                    />
                  </GridItem>

                  <GridItem xs={12}>
                    <Button
                      color="success"
                      disabled={!this.state.selected_survey}
                      onClick={this.generateLocationPdf}
                    >
                      {t('Generate QR PDF')} ({this.computeLocations().length} {t('locations')})
                    </Button>
                  </GridItem>
                </GridContainer>

                {/* Off-screen QR canvases rendered just before export */}
                <div ref={this.locationWrapRef} style={{ position: 'absolute', left: -99999, top: 0 }} aria-hidden="true">
                  {this.state.pdfLocations.map((loc, i) => (
                    <div id={`loc-qr-${i}`} key={i}>
                      <QRCode value={this.locationQrUrl(loc)} level={this.state.selected_level.value} size={256} />
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });
export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(CreateSurveyLinkPage)));